import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  container: {
    height: 'inherit',
  },
}))

export default styles
